export default __webpack_public_path__ + "static/media/DEPRESSIONE_ICONA.0bcf9bfc.svg";